import React, { useState } from "react";

const ExpandableText = ({ text, limit = 100 }) => {
    const [expanded, setExpanded] = useState(false);

    if (!text) return null;

    const isLong = text.length > limit;
    const displayText = expanded || !isLong ? text : text.slice(0, limit) + "…";

    return (
        <div 
            className="text-blue-600 cursor-pointer whitespace-pre-wrap break-words max-w-full"
            onClick={() => setExpanded(!expanded)}
            title={expanded ? "Скрыть" : "Показать полностью"}
            style={{
                wordBreak: 'break-word',
                maxWidth: '100%',
                display: 'inline-block'
            }}
        >
            {displayText}
        </div>
    );
};

export default ExpandableText;